<template>
    <Alert v-if="alertContent || loadingMood" :loadingMood="loadingMood" :alertContent="alertContent" @close="alertContent=''"/>
    <div id="register-container" >
        <img src="../assets/appIcons/Pics/Flag.png" id="flag" alt="">
        <form class="row" id="personal-form-container" v-on:submit.prevent="handelSubmit">
            <div id="register-form-content">
                <div class="row" style="position: relative;border-top: 1px solid #bbc5d6;;padding-top: 40px">

                    <div class="title form-title">
                        <ul>
                            <li>
                                <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                            </li>
                            <li>
                                اطلاعات کاربری
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-8 co-md-6 col-sm-12" style="padding: 0;margin: 0">
                        <div class="form-group">
                            <div class="input-container" style="padding: 0!important;margin: 0!important;">
                                <input v-model="data.name" placeholder="نام و نام خانوادگی"  class="form-input-one custom-input" type="text" required>
                                <input v-model="data.mobile" placeholder="شماره موبایل" pattern="09(0[1-2]|1[0-9]|3[0-9]|2[0-1])-?[0-9]{3}-?[0-9]{4}"  class="form-input-one custom-input" type="number" required>
                            </div>
                            <div class="input-container" style="padding: 0!important;margin: 0!important;">
                                <div class="select-container form-input-one custom-input">
                                    <img width="7" height="5" src="../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                                    <select v-model="data.last_educational_certificate">
                                        <option  value="null" selected>آخرین مدرک تحصیلی</option>
                                        <option value="سیکل">سیکل</option>
                                        <option value="دیپلم">دیپلم</option>
                                        <option value="فوق دیپلم">فوق دیپلم</option>
                                        <option value="لیسانس">لیسانس</option>
                                        <option value="فوق لیسانس">فوق لیسانس</option>
                                        <option value="دکترا">دکترا</option>
                                        <option value="فوق دکترا">فوق دکترا</option>
                                    </select>
                                </div>
                                <input v-model="data.last_degree_study_field" placeholder="رشته تحصیلی آخرین مدرک تحصیلی"  class="form-input-one custom-input" type="text" required>
                            </div>
                        </div>
                        <div class="form-group" style=";font-size: 14px;text-align: right;">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12" style="padding: 10px 20px 10px 10px;font-size: 13px">
                                    آیا مدرک آیلتس دارید؟
                                    <input v-model="data.IELTS_status" value="1" class="checkbox" type="radio" id="c5">
                                    <label for="c5">
                                        <img  v-if="data.IELTS_status==1"  width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Filled.png" alt="">
                                        <img  v-else width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Empty.png" alt="">
                                        بله
                                    </label>
                                    <input v-model="data.IELTS_status" value="0" class="checkbox" type="radio" id="c6" name="cb">
                                    <label for="c6" style="margin-right: 5%">
                                        <img   v-if="data.IELTS_status == 0" width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Filled.png" alt="">
                                        <img   v-else width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Empty.png" alt="">
                                        خیر
                                    </label>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <div  v-if="data.IELTS_status==1" class="select-container custom-input IELTS-input">
                                        <img width="7" height="5" src="../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                                        <select  v-model="data.language_level" required>
                                            <option value="null" selected>نمره ی آیلتس</option>
                                            <option v-for="score in IELTS_scors" :value="score" :key="score">
                                                {{score}}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-else class="select-container custom-input IELTS-input">
                                        <img width="7" height="5" src="../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                                        <select  v-model="data.language_level">
                                            <option value="null" selected>سطح زبان</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 co-md-6 col-sm-12" style="padding: 0!important;margin: 0!important;">

                        <div class="input-container" style="padding: 0!important;margin: 0!important;">
                            <label style="font-size: 14px"> تاریخ تولد</label>
                            <select  class="custom-input form-input-two" v-model="data.birth_date.day" v-on:keyup="checkValue('age')" required>
                                <option value="null" selected>روز</option>
                                <option v-for="day in 31" :value="day" :key="day">
                                    {{day}}
                                </option>
                            </select>
                            <select  class="custom-input form-input-two" v-model="data.birth_date.month" v-on:keyup="checkValue('age')" required>
                                <option value="null" selected>ماه</option>
                                <option v-for="month in 12" :value="month" :key="month">
                                    {{month}}
                                </option>
                            </select>
                            <select  class="custom-input form-input-two" v-model="data.birth_date.year" v-on:keyup="checkValue('age')" required>
                                <option value="null" selected>سال</option>
                                <option v-for="year in years()" :value="year" :key="year">
                                    13{{year}}
                                </option>
                            </select>
                        </div>

                        <div class="form-group" style="margin-top: 15px;font-size: 14px;text-align: right;">
                            وضعیت تاهل:
                            <input v-model="data.marital_status" value="0" class="checkbox" type="radio" id="c3">
                            <label for="c3">
                                <img  v-if="data.marital_status==0"  width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Filled.png" alt="">
                                <img  v-else width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Empty.png" alt="">
                                مجرد
                            </label>
                            <input v-model="data.marital_status" value="1" class="checkbox" type="radio" id="c4" name="cb">
                            <label for="c4" style="margin-right: 5%">
                                <img   v-if="data.marital_status==1" width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Filled.png" alt="">
                                <img   v-else width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Empty.png" alt="">
                                متاهل
                            </label>
                        </div>
                    </div>

                </div>
                <div class="row" style="position: relative;border-top: 1px solid #bbc5d6;margin-top: 50px;;padding-top: 40px">
                    <div class="title form-title">
                        <ul>
                            <li>
                                <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                            </li>
                            <li>
                                اطلاعات مهاجرتی
                            </li>
                        </ul>
                    </div>
                    <div style="width: 100%;text-align: right">
                        <div class="form-group">
                            <div class="input-container">
                                <input v-model="data.job_title" placeholder="عنوان شغل"   class="custom-input form-input-one" type="text" required>
                                <select  class="custom-input work-experience" v-model="data.work_experience_amount" required>
                                    <option value="null" selected>میزان سابقه کار</option>
                                    <option v-for="year in 40" :value="year" :key="year">
                                        {{year}}

                                        سال
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="question">
                        <img style="margin-top: 7px" width="6" height="8" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                          <span style="margin-right: 5px">
                            شرایط شما برای چه برنامه هایی سنجیده می شود؟
                        </span>
                    </div>
                    <div class="options">
                        <span v-for="(option , index) in options" :key="option">
                            <input :id="'ac'+index"  v-model="data.assessment_conditions_ids" :value="option.id" class="checkbox" type="checkbox">
                            <label :for="'ac'+index">
                                <img   v-if="data.assessment_conditions_ids.includes(option.id)" width="18" height="18" src="../assets/appIcons/Icon/Chechbox/Checked.png" alt="">
                                <img   v-else width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Empty.png" alt="">
                                {{option.option}}
                            </label>
                        </span>
                    </div>
                    <div class="question">
                        <img style="margin-top: 7px" width="6" height="8" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                        <span style="margin-right: 5px">
                          اگر شرایط خاص دارید توضیح دهید:
                        </span>
                    </div>
                    <div class="options">
                        <textarea v-model="data.special_condition_description" class="specialCondition" cols="30" rows="10"></textarea>
                    </div>
                    <!--0020-->
                    <div class="question">
                        <img style="margin-top: 7px" width="6" height="8" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                        <span style="margin-right: 5px">
                              از چه طریق با
                        <span style="color: #fe7063">کانادا از ایران</span>
                        آشنا شده اید؟
                        </span>
                    </div>
                    <div class="options">

                        <input v-model="data.acquainted" value="اینستاگرام" class="checkbox" type="radio" id="c14">
                        <label for="c14">
                            <img   v-if="data.acquainted=='اینستاگرام'" width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Filled.png" alt="">
                            <img   v-else width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Empty.png" alt="">
                            اینستاگرام
                        </label>



                        <input v-model="data.acquainted" value="کانال تلگرام" class="checkbox" type="radio" id="c15">
                        <label for="c15">
                            <img    v-if="data.acquainted=='کانال تلگرام'" width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Filled.png" alt="">
                            <img   v-else width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Empty.png" alt="">
                            کانال تلگرام
                        </label>


                        <input v-model="data.acquainted" value="معرفی دوستان" class="checkbox" type="radio" id="c16">
                        <label for="c16">
                            <img    v-if="data.acquainted=='معرفی دوستان'" width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Filled.png" alt="">
                            <img   v-else width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Empty.png" alt="">
                            معرفی دوستان
                        </label>


                        <input v-model="data.acquainted" value="اس ام اس" class="checkbox" type="radio" id="c17">
                        <label for="c17">
                            <img   v-if="data.acquainted=='اس ام اس'" width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Filled.png" alt="">
                            <img   v-else width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Empty.png" alt="">
                            اس ام اس
                        </label>


                        <input v-model="data.acquainted" value="جستوجو در اینترنت" class="checkbox" type="radio" id="c18">
                        <label for="c18">
                            <img   v-if="data.acquainted=='جستوجو در اینترنت'" width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Filled.png" alt="">
                            <img   v-else width="18" height="18" src="../assets/appIcons/Icon/RadioButton/Empty.png" alt="">
                            جستوجو در اینترنت
                        </label>
                    </div>
                </div>
                <button type="submit">ثبت و اعمال تغییرات</button>
            </div>
        </form>
    </div>
</template>

<script>
    import axios from "axios";
    import Alert from "../components/Alert"

    export default {
        name: "PersonalInfo",
        data () {
            return {
                IELTS_scors:[3.5,4,4.5,5,5.5,6,6.5,7,7.5,8,8.5,9],
                data:{
                    birth_date:
                        {
                            year:null,
                            month:null,
                            day:null
                        },//سره هم شود<-
                    name:null,//->داخل جدول users هم ذخیره شود
                    assessment_conditions_ids:[],//در قالب استرینگ ذخیره شود
                    acquainted:null,//ok
                    last_degree_study_field:null,//ok
                    job_title:null,//ok
                    marital_status:null,
                    work_experience_amount:null,//ok
                    last_educational_certificate:null,//ok
                    mobile:null,//ok
                    IELTS_status:null,//ok
                    language_level:null,//ok
                    special_condition_description:null//0020
                },
                alertContent:null,
                loadingMood:false,
                options:null
            }
        },
        components:{
            Alert
        },
        methods: {
            years(){
                let years = [];
                var i = 0;
                for (i=99;i>=10;i--){
                    years.push(i)
                }
                return years;
            },
            async handelSubmit() {
                try {
                    this.loadingMood=true;
                    await axios.post('api/userDashboard/personalInfoStore', {data:this.data}, {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}}
                    );
                    this.loadingMood=false;
                    let date = new Date();
                    localStorage.setItem('loginStatus','true');
                    localStorage.setItem('date', date.getTime() / 1000);
                    this.$store.state.preliminaryReview = true;
                    this.$store.state.loginStatus = true;
                    this.alertContent={
                        message: 'اطلاعات کاربری شما با موفقیت ذخیره شد!',
                        imageUrl:require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'link',//close
                        buttonText:'ورود به داشبورد',
                        buttonLink:'/user-panel',
                        waitingMode:false
                    };
                }
                catch (error) {
                    this.loadingMood=false;
                    console.log(error.response.data.status);
                    if(error.response.data.status=='repetitive_save_request'){
                        this.alertContent={
                            message: 'خطا در انجام عملیات!',
                            notice:error.response.data.errors,
                            imageUrl:require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                            buttonType: 'link',
                            buttonText: 'ورود به داشبورد',
                            buttonLink: '/user-panel',
                            closeButtonShow:true,
                            waitingMode:false
                        };
                    }else{
                        this.alertContent={
                            message: 'خطا در انجام عملیات!',
                            notice:error.response.data.errors,
                            imageUrl:require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                            buttonType : 'close',
                            buttonText : 'تایید',
                            buttonLink : '',
                            closeButtonShow:true,
                            waitingMode:false
                        };
                    }

                }
            },
            async getAssessmentConditions() {
                try {
                    this.loadingMood=true;
                    let response = await axios.get('api/assessmentConditions');
                    this.options = response.data.results;
                    this.loadingMood=false;
                }
                catch (error) {
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'خطا در انجام عملیات!',
                        notice:error.response.data.errors,
                        imageUrl:require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType : 'close',
                        buttonText : 'تایید',
                        buttonLink : '',
                        closeButtonShow:true,
                        waitingMode:false
                    };
                }
            },
            checkValue(type){
                if(type=='age'){
                    if(this.data.birth_date.month > 12 || this.data.birth_date.month<0){
                        this.data.birth_date.month = 0;
                    }
                    if(this.data.birth_date.day > 31 || this.data.birth_date.day<0){
                        this.data.birth_date.day = 0;
                    }
                    if(this.data.birth_date.year > 99 || this.data.birth_date.year<0){
                        this.data.birth_date.year = 0;
                    }
                }
            }
        },
        updated() {
            if(this.data.assessment_conditions_ids.length>2){
                const my_object = this.data.assessment_conditions_ids;
                const sliced = [];
                for (var i=0; i<=1; i++){
                    sliced[i] = my_object[2-i];
                }
                this.data.assessment_conditions_ids=sliced;
            }
        },

        created(){
            this.getAssessmentConditions();
        },

    }
</script>

<style lang="scss" scoped>
    .form-group{
        text-align: right!important;
    }
    .input-container{
        text-align: right!important;
    }
    .specialCondition{
        width:100%;
        height: 100px;
        opacity: 0.5;
        border-radius: 5px;
        border: solid 0.5px #162336;
        padding: 15px;
    }


    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }


    .select-container{
        position: relative;
        opacity: 1!important;
        select{
            border: none;
            width: 100%;
            height: 100%;
            border-radius: 5px;
            opacity: 1;
        }
        img{
            position: absolute;
            top: 0;
            bottom: 0;
            margin-top: auto;
            margin-bottom: auto;
            left: 15px;
            z-index: 10;
        }
    }
    select{
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';
    }
    button:hover{
        background-color: #fe7063!important;
        border: none;
    }

    .title {
        margin-top: -20px;
        text-align: right;
        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
        padding: 0;
        right: 0;

        ul {
            display: flex;
            align-items: center;
            justify-content: right;
            list-style-type: none;
            padding: 0;

            li {
                background-color: white;
                padding: 0 0 0 15px;
                img {
                    margin-top: 5px;
                    width: 9px !important;
                    height: auto !important;
                }


                font-size: 22px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: justify;
                color: #1a1a1a;



                display: inline-block;

                span {
                    color: #cc171d;
                }
            }
        }

    }

    #flag{
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        opacity: 0.05;
        z-index: 1;
    }


    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: black;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        color: black;
    }
    :-ms-input-placeholder { /* IE 10+ */
        color: black;
    }
    :-moz-placeholder { /* Firefox 18- */
        color: black;
    }
    .IELTS-input{
        font-size: 13px;
        width: 120px;
        height: 40px;
        display: inline-block!important;
        margin: 0!important;
    }
    .form-input-two{
        width: 20%;
        display: inline-block;
        margin: 5px!important;
    }
    .form-input-one{
        width: 100%;
        display: inline-block;
        margin: 5px!important;
    }
    .input-container{
        width: 100%;
        height: auto;
        /*background-color: red;*/
    }
    input , select{
        padding-right: 15px!important;
        padding-left: 15px!important;
    }

    /*****/



    .work-experience{
        margin: 5px!important;
        max-width: 150px!important;
        width: 50%!important;
    }

    .row{
        padding-right: 0;
        padding-left: 0;
    }
    .form-title {
        font-size: 22px !important;
    }
    .title {
        margin-top: -20px;
        text-align: right;
        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
        padding: 0;
        right: 0;

        ul {
            display: flex;
            align-items: center;
            justify-content: right;
            list-style-type: none;
            padding: 0;

            li {
                background-color: white;
                padding: 0 0 0 15px;
                img {
                    margin-top: 5px;
                    width: 9px !important;
                    height: auto !important;
                }


                font-size: 22px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: justify;
                color: #1a1a1a;



                display: inline-block;

                span {
                    color: #cc171d;
                }
            }
        }

    }




    label{
        margin-right: 5px;
    }

    button{
        color: white;
        max-width: 280px;
        width: 100%;
        height: 50px;
        margin: 40px auto -40px auto;
        border-radius: 5px;
        font-size: 15px;
        background-color: #162336;
    }
    #final-information{
        width: 100%;
        text-align: center;
        margin-top: 50px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
    }
    .options{
        cursor: pointer;
        text-align: right;
        width: 101%;
        padding-top: 20px;
    }
    .question{
        display: flex;
        justify-content: flex-start;
        align-items: center;//0020
        width:100%;
        text-align: right;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        margin-top: 25px;//0020
    }


    p {
        margin: 1.5em 0;
        padding: 0;
    }



    .checkbox{
        position: absolute;
    }
    input[type="checkbox"] {
        visibility: hidden;
    }
    label {
        cursor: pointer;
    }
    input[type="checkbox"] + label:before {
        display: none;
        border: 2px solid  #fe7063;
        content: "\00a0";
        /*display: inline-block;*/
        font: 16px/1em sans-serif;
        height: 16px;
        margin: 0 .25em 0 0;
        padding: 0;
        vertical-align: top;
        width: 16px;
    }
    input[type="checkbox"]:checked + label:before {
        background: #fe7063;
        color:  white;
        content: "\2713";
        text-align: center;
    }
    input[type="checkbox"]:checked + label:after {
        font-weight: bold;
    }

    input[type="checkbox"]:focus + label::before {
        outline: rgb(59, 153, 252) auto 5px;
    }
    input[type='radio']{
        visibility: hidden;
    }
    label{
        font-size: 14px;
    }
    /******/



    .input-group{
        justify-content: right;
    }
    .title{
        background-color: white;
        position: absolute;
        right: 0;
        top: -5px;
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: justify;
        color: #1a1a1a;
    }
    #personal-form-container{
        z-index: 10;
        position: relative;
        padding: 50px 30px 50px 30px;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0 0 12px 0 rgba(22, 35, 54, 0.2);
    }

    .custom-input{
        text-align: right;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        max-width: 270px;
        height: 40px;
        border-radius: 5px!important;
        opacity: 1;
        border: solid 2px lightgray;
        margin: 20px;
    }

    select{
        cursor: pointer;
        option{
            cursor:pointer!important; ;
        }
        /*text-align: right;*/
        /*font-size: 13px;*/
        /*font-weight: normal;*/
        /*font-stretch: normal;*/
        /*font-style: normal;*/
        /*line-height: normal;*/
        /*letter-spacing: normal;*/
        /*color: #162336;*/
        /*max-width: 265px;*/
        /*height: 40px;*/
        /*border-radius: 5px!important;*/
        /*opacity: 0.5;*/
        /*border: solid 2px lightgray;*/
        /*margin: 20px;*/
    }
    #register-form-content{
        width: 100%;
        height: auto;
    }

    #register-form-content>form{
        margin-top: 50px;
    }

    #edit-personal-infos{
        padding:30px;
    }

    #register-container{
        /*background-image: url("../assets/appIcons/Pics/Flag.png");*/
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 10px;
        position: relative;
        height: auto;
        background-color: white;
        width: 100%;
        max-width: 970px;
        padding: 50px 40px;
        margin: auto;
        margin-bottom: 50px;
    }


    @media (max-width: 1000px) {
        #flag{
            display: none;
        }
        #register-container{
            background-color: transparent;
        }
    }

</style>